export default "__VITE_ASSET__sv5a1eK___"